import { PartialBalanceInfo } from '.';
import * as api from '../../../api';

export const isPartialBalanceValid = (
  amount: PartialBalanceInfo['amount'],
  previousBalance: number,
) => {
  if (amount === null) return false;
  if (amount < 50 || amount >= previousBalance) {
    return false;
  }

  return true;
};

export const showPayments = (args: {
  copayPrepayDisplaySetting: api.PracticePreference.CopayPrepayDisplaySetting;
  previousBalanceCollectionSetting: api.PracticePreference.PreviousBalanceCollectionSetting;
  visitFeeAmount: number | undefined;
  prepayAmount: number | null | undefined;
  previousBalance: number | undefined;
  paymentPrimitiveConfigs: api.PrevisitFormTemplateFieldConfig.PaymentPrimitiveConfigs;
}): {
  showCopay: boolean;
  showPrepay: boolean;
  showPreviousBalance: boolean;
} => {
  const {
    copayPrepayDisplaySetting,
    previousBalanceCollectionSetting,
    visitFeeAmount,
    prepayAmount,
    previousBalance,
    paymentPrimitiveConfigs,
  } = args;
  const nonzeroCopay = !!visitFeeAmount && visitFeeAmount > 0;
  const nonzeroPrepay = !!prepayAmount && prepayAmount > 0;
  let showPreviousBalance =
    !!previousBalance &&
    previousBalance > 0 &&
    previousBalanceCollectionSetting !==
      api.PracticePreference.PreviousBalanceCollectionSetting.Off;
  let showCopay = nonzeroCopay,
    showPrepay = nonzeroPrepay;
  switch (copayPrepayDisplaySetting) {
    case api.PracticePreference.CopayPrepayDisplaySetting.CopayAndPrepay:
      break;
    case api.PracticePreference.CopayPrepayDisplaySetting.CopayIfNoPrepay:
      showCopay = !nonzeroPrepay && nonzeroCopay;
      showPrepay = false;
      break;
    case api.PracticePreference.CopayPrepayDisplaySetting.CopayOnly:
      showCopay = nonzeroCopay;
      showPrepay = false;
      break;
    case api.PracticePreference.CopayPrepayDisplaySetting.PrepayOverCopay:
      showCopay = !nonzeroPrepay && nonzeroCopay;
      showPrepay = nonzeroPrepay;
      break;
  }
  if (paymentPrimitiveConfigs.hideCopay) {
    showCopay = false;
  }
  if (paymentPrimitiveConfigs.hidePrePay) {
    showPrepay = false;
  }
  return {
    showCopay,
    showPrepay,
    showPreviousBalance,
  };
};
